import React from "react";
import { Button, UpgradeTooltip } from "components";
import { useTranslation } from "react-i18next";
import {
  useGetTherapistFiles,
  useActiveOrganizationPlanLimits,
} from "utils/hooks";

interface AddFileButtonProps {
  onClick: () => void;
  title?: string;
  icon?: string;
}

const AddFileButton = ({ onClick, title, icon }: AddFileButtonProps) => {
  const { therapistFiles } = useGetTherapistFiles({});
  const { fileLimit } = useActiveOrganizationPlanLimits();

  // if the user doesn't have a plan they are likley a patient who cannot currently add files anyway
  const limitReached = therapistFiles?.length >= fileLimit;

  const { t } = useTranslation(["common"]);
  return (
    <div data-tip data-for="file-upgrade-tip">
      <Button
        name="add_file_button"
        value={title || t("resources.add_file_button")}
        pill
        icon={icon || "FileBold"}
        size="small"
        onClick={onClick}
        disabled={limitReached}
      />
      {limitReached && (
        <UpgradeTooltip
          tooltipId="file-upgrade-tip"
          limitedEntity="files"
          offset={{ left: 0 }}
        />
      )}
    </div>
  );
};

export default AddFileButton;
